import { RowCrudStatus } from "../../common/types";
import { EsignatureRecipient } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { EsignatureRecipientStatus } from "../../../api/graphql";

export type EsignatureRecipientValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  status: EsignatureRecipientStatus;
  signedAt: Date | null;
};

export type EsignatureRecipientErrorsType = {
  status?: { message: string; fieldLabel: string };
  signedAt?: { message: string; fieldLabel: string };
};

export function EsignatureRecipientValuesInit(): EsignatureRecipientValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    status: "pending" as EsignatureRecipientStatus,
    signedAt: null,
  };
}

export type EsignatureRecipientType =
  | EsignatureRecipient
  | EsignatureRecipientValuesType;

export function esignatureRecipientDisplayId(
  source: Partial<EsignatureRecipient>,
  _langStore: LangStore
) {
  return (
    (source.name ?? _langStore.emptyStringSymbol) +
    " - " +
    (source.email ?? _langStore.emptyStringSymbol)
  );
}

export function getEsignatureRecipientValues(
  source: EsignatureRecipientType,
  _langStore: LangStore,
  _duplicated: boolean = false
): EsignatureRecipientValuesType {
  const entityValues = EsignatureRecipientValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : esignatureRecipientDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.status = source.status;
  entityValues.signedAt = source.signedAt ? new Date(source.signedAt) : null;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
